<template lang="pug">
  #right-click-menu(
    ref='rightMenu', v-if='rightMenuVisible',
    @blur='closeRightClickMenu',
    :style='{ top, left }'
  )
    //- EDIT
    p.right-click-menu-parent(
      id="RightClickPlayitemMenu-editButton",
      @mouseover="displaySection = 'edit'",
      @mouseleave="displaySection = undefined",
      @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'PlayProperties'})"
    )
      font-awesome-icon.icon(icon="edit")
      span &nbsp; {{ $t('Edit') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'edit'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
        p.right-click-menu-item(id="RightClickPlayitemMenu-editSourceButton", @click.stop="rightClickPlayitemAction('showMediumBasicEditor', rightClickedItem)")
          font-awesome-icon.icon(icon="film")
          span &nbsp; {{ $t('Edit source medium') }}
        p.right-click-menu-item(id="RightClickPlayitemMenu-showDisplayPropertiesButton", @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'PlayProperties'})")
          font-awesome-icon.icon(icon="palette")
          span &nbsp; {{ $t('Display properties') }}
        p.right-click-menu-item(id="RightClickPlayitemMenu-showTimeRestrictionsButton", @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'TimeRestrictions'})")
          font-awesome-icon.icon(icon="clock")
          span &nbsp; {{ $t('Time restrictions') }}
        p.right-click-menu-item(
          v-if='playlistInStore.type === "PlayListLayout"',
          id="RightClickPlayitemMenu-zonePropertiesButton",
          @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'Zone'})"
        )
          font-awesome-icon.icon(icon="crop")
          span &nbsp; {{ $t('Zone properties') }}
        p.right-click-menu-item(id="RightClickPlayitemMenu-exceptionsButton", @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'PlayerExeptions'})")
          font-awesome-icon.icon(icon="ban")
          span &nbsp; {{ $t('Player exceptions') }}
        p.right-click-menu-item(id="RightClickPlayitemMenu-synchronizationButton", @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'Synchro'})")
          font-awesome-icon.icon(icon="stopwatch")
          span &nbsp; {{ $t('Synchronization') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-configureButton",
          @click.stop="rightClickPlayitemAction('showPlayListItemModify', { item: rightClickedItem, restriction: 'configurePlayListItem'})",
          :class="{ disabled: !(rightClickedItem.Medium.type === 'PlayListExtended' || rightClickedItem.Medium.type === 'HTML5app') }"
        )
          font-awesome-icon.icon(icon="cogs")
          span &nbsp; {{ $t('Configure') }}
        //- p.right-click-menu-item(
        //-   @click.stop="rightClickPlayitemAction('configurePlayListItem', rightClickedItem)",
        //-   :class="{ disabled: !(rightClickedItem.Medium.type === 'PlayListExtended' || rightClickedItem.Medium.type === 'HTML5app') }"
        //- )
    //- COPY
    p.right-click-menu-parent(
      id="RightClickPlayitemMenu-copyButton",
      @mouseover="displaySection = 'copy'",
      @mouseleave="displaySection = undefined"
    )
      font-awesome-icon.icon(icon="copy")
      span &nbsp; {{ $t('Copy') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'copy'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-copyDisplayPropertiesButton",
          @click.stop="rightClickPlayitemAction('copyPlayProperties', rightClickedItem)",
          :class="{ disabled: !itemHasPlayRestrictions(rightClickedItem) }"
        )
          font-awesome-icon.icon(icon="palette")
          span &nbsp; {{ $t('Display properties') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-copyRestrictionsButton",
          @click.stop="rightClickPlayitemAction('copyTimeRestrictions', rightClickedItem)",
          :class="{ disabled: !(itemHasDayTimeRestrictions(rightClickedItem) || itemHasDateRestrictions(rightClickedItem)) }"
        )
          font-awesome-icon.icon(icon="clock")
          span &nbsp; {{ $t('Time restrictions') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-copyExceptionsButton",
          @click.stop="rightClickPlayitemAction('copyPlayerExceptions', rightClickedItem)",
          :class="{ disabled: !itemHasPlayerExeptions(rightClickedItem) }"
        )
          font-awesome-icon.icon(icon="ban")
          span &nbsp; {{ $t('Player exceptions') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-copySynchronizationButton",
          @click.stop="rightClickPlayitemAction('copySynchroListener', rightClickedItem)",
          :class="{ disabled: !itemHasSynchroListener(rightClickedItem) }"
        )
          font-awesome-icon.icon(icon="stopwatch")
          span &nbsp; {{ $t('Synchronization listener') }}
    //- PASTE
    p.right-click-menu-parent(
      id="RightClickPlayitemMenu-pasteButton",
      @mouseover="displaySection = 'paste'",
      @mouseleave="displaySection = undefined"
    )
      font-awesome-icon.icon(icon="paste")
      span &nbsp; {{ $t('Paste') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'paste'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-pasteDisplayPropertiesButton",
          @click.stop="rightClickPlayitemAction('pastePlayProperties', rightClickedItem)",
          :class="{ disabled: !copiedPlayPropertiesExistsInStore }"
        )
          font-awesome-icon.icon(icon="palette")
          span &nbsp; {{ $t('Display properties') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-pasteRestrictionsButton",
          @click.stop="rightClickPlayitemAction('pasteTimeRestrictions', rightClickedItem)",
          :class="{ disabled: !copiedDateTimeRestrictionExistsInStore }"
        )
          font-awesome-icon.icon(icon="clock")
          span &nbsp; {{ $t('Time restrictions') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-pasteExceptionsButton",
          @click.stop="rightClickPlayitemAction('pastePlayerExceptions', rightClickedItem)",
          :class="{ disabled: !copiedPlayerExceptionsExistsInStore }"
        )
          font-awesome-icon.icon(icon="ban")
          span &nbsp; {{ $t('Player exceptions') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-pasteSynchronizationButton",
          @click.stop="rightClickPlayitemAction('pasteSynchroListener', rightClickedItem)",
          :class="{ disabled: !copiedSynchroListenerExistsInStore }"
        )
          font-awesome-icon.icon(icon="stopwatch")
          span &nbsp; {{ $t('Paste synchro listener') }}
    //- CLEAR
    p.right-click-menu-parent(
      id="RightClickPlayitemMenu-clearButton",
      @mouseover="displaySection = 'clear'",
      @mouseleave="displaySection = undefined"
    )
      font-awesome-icon.icon(icon="trash")
      span &nbsp; {{ $t('Clear') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'clear'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-clearDisplayPropertiesButton",
          @click.stop="rightClickPlayitemAction('clearPlayProperties', rightClickedItem)",
        )
          font-awesome-icon.icon(icon="palette")
          span &nbsp; {{ $t('Display properties') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-clearRestrictionsButton",
          @click.stop="rightClickPlayitemAction('clearTimeRestrictions', rightClickedItem)",
        )
          font-awesome-icon.icon(icon="clock")
          span &nbsp; {{ $t('Time restrictions') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-clearExceptionsButton",
          @click.stop="rightClickPlayitemAction('clearPlayerExceptions', rightClickedItem)",
        )
          font-awesome-icon.icon(icon="ban")
          span &nbsp; {{ $t('Player exceptions') }}
        p.right-click-menu-item(
          id="RightClickPlayitemMenu-clearSynchronizationButton",
          @click.stop="rightClickPlayitemAction('clearSynchroListener', rightClickedItem)",
        )
          font-awesome-icon.icon(icon="stopwatch")
          span &nbsp; {{ $t('Synchro listener') }}
    //- EXTRACT
    p.right-click-menu-parent(
      id="RightClickPlayitemMenu-extractButton",
      @mouseover="displaySection = 'extract'",
      @mouseleave="displaySection = undefined"
    )
      font-awesome-icon.icon(icon="sign-in-alt")
      span &nbsp; {{ $t('Extract') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'extract'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
        p.right-click-menu-item(id="RightClickPlayitemMenu-extractIntoPlaylistButton", @click.stop="rightClickPlayitemAction('extractIntoPlaylist', rightClickedItem)")
          font-awesome-icon.icon(icon="film")
          span &nbsp; {{ $t('into Playlist') }}
        p.right-click-menu-item(id="RightClickPlayitemMenu-extractIntoLayoutButton", @click.stop="rightClickPlayitemAction('extractIntoLayout', rightClickedItem)")
          font-awesome-icon.icon(icon="layer-group")
          span &nbsp; {{ $t('into Layout') }}
    //- Other
    //- p.right-click-menu-parent
    //-   span &nbsp; {{ $t('Other') }}
    p.right-click-menu-parent(id="RightClickPlayitemMenu-removeButton", @click.stop="rightClickPlayitemAction('showPlayListItemUnlink', rightClickedItem)")
      font-awesome-icon.icon(icon="unlink")
      span &nbsp; {{ $t('Remove from playlist') }}
    p.right-click-menu-parent(
      id="RightClickPlayitemMenu-cloneButton",
      @click.stop="rightClickPlayitemAction('clonePlayitems', rightClickedItem)",
    )
      font-awesome-icon.icon(icon="copy")
      span &nbsp; {{ $t('Clone playitems') }}
    p.right-click-menu-parent(id="RightClickPlayitemMenu-usageButton", @click.stop="rightClickPlayitemAction('loadMediumUsageInMediaEditor', rightClickedItem)")
      font-awesome-icon.icon(icon="broadcast-tower")
      span &nbsp; {{ $t('Medium usage') }}
</template>

<script>
import Vue from 'vue'
import MediumIcon from '../Common/MediumIcon'
import MediaUtilsMixin from '../Common/mediaUtils.mixin'

export default {
  props: [],
  mixins: [MediaUtilsMixin],
  components: {
    MediumIcon
  },
  data () {
    return {
      rightMenuVisible: false,
      top: '0px',
      left: '0px',
      mediumInFocus: undefined,
      rightClickedItem: undefined,
      displaySection: undefined
    }
  },
  methods: {
    rightClickPlayitemAction (action, data) {
      this.$emit(action, data)
      this.closeRightClickMenu()
    },
    showPlayListItemModify (item, restriction) {
      this.$emit('showPlayListItemModify', { item, restriction })
    },
    showMediumBasicEditor (item) {
      this.$emit('showMediumBasicEditor', item)
    },
    showPlayListItemUnlink (item) {
      this.$emit('showPlayListItemUnlink', item)
    },
    // RIGHT-CLICK
    setRightClickMenuPosition (top, left) {
      const largestHeight = window.innerHeight - this.$refs.rightMenu.offsetHeight - 25
      const largestWidth = window.innerWidth - this.$refs.rightMenu.offsetWidth - 25

      if (top > largestHeight) top = largestHeight

      if (left > largestWidth) left = largestWidth

      this.top = top + 'px'
      this.left = left + 'px'
    },
    closeRightClickMenu () {
      this.displaySection = undefined
      this.rightMenuVisible = false
      this.rightClickedItem = undefined
    },
    openRightClickMenu (item, $event) {
      if (
        !$event.ctrlKey &&
        !$event.metaKey &&
        this.$store.state.Medium.playitems_selected_right.findIndex(plis => plis.id === item.id) === -1
      ) {
        this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [item])
      } else {
        if (this.$store.state.Medium.playitems_selected_right.findIndex(plis => plis.id === item.id) === -1) {
          this.$store.commit('Medium/ADD_PLAYITEM_SELECTED_RIGHT', item)
        }
      }
      this.rightClickedItem = item
      this.rightMenuVisible = true
      Vue.nextTick(() => {
        // this.$refs.rightMenu.focus()
        this.setRightClickMenuPosition($event.y, $event.x)
      })
      $event.preventDefault()
    },
    itemHasDayTimeRestrictions (item) {
      return (item.PlayListItem_DaytimeRestrictions && item.PlayListItem_DaytimeRestrictions.length > 0)
    },
    itemHasDateRestrictions (item) {
      return (item.PlayListItem_DateRestrictions && item.PlayListItem_DateRestrictions.length > 0)
    },
    itemHasPlayerExeptions (item) {
      const playOnlyInMedia = JSON.parse(item.playOnlyInMedia)
      const playForbiddenInMedia = JSON.parse(item.playForbiddenInMedia)
      if (playOnlyInMedia === null && playForbiddenInMedia === null) return false
      return playOnlyInMedia.length > 0 || playForbiddenInMedia.length > 0
    },
    itemHasPlayRestrictions (item) {
      return item.playDurationMs > 0 || item.playOffsetMs !== 0 || item.objectFit !== 'default'
    },
    itemHasSynchroListener (item) {
      if (!item.listenSynchronize) return false
      return item.listenSynchronize.length > 0
    }
  },
  computed: {
    innerWidthValue () {
      return window.innerWidth
    },
    rightFreeSpace () {
      return window.innerWidth - parseInt(this.left.replace('px', ''))
    },
    playlistInStore () {
      return this.$store.state.Medium.media_list.find(m => m.id === this.rightClickedItem.PlayList)
    },
    mediaTags () {
      return this.$store.state.Medium.media_tags
    },
    mediaFilterTagsLength () {
      return this.$store.state.Medium.media_filter[this.side].mediaTags.length
    },
    copiedDateTimeRestrictionExistsInStore () {
      return this.$store.state.Clipboard.copied_playlistitem_daytime_restrictions.length !== 0 ||
      this.$store.state.Clipboard.copied_playlistitem_date_restrictions.length !== 0
    },
    copiedPlayerExceptionsExistsInStore () {
      return Object.keys(this.$store.state.Clipboard.copied_player_exceptions).length > 0
    },
    copiedPlayPropertiesExistsInStore () {
      return Object.keys(this.$store.state.Clipboard.copied_play_properties).length > 0
    },
    copiedSynchroListenerExistsInStore () {
      return this.$store.state.Clipboard.copied_synchro_listener.length > 0
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
@import "../Common/rightClick.scss";
</style>



// WEBPACK FOOTER //
// src/components/Medium/RightClickPlayItemMenu.vue